import React from 'react';
import styled from '@emotion/styled';

const AlertWrapper = styled.div`
  position: relative;
  background: ${props => props.background};
  padding: 8px 25px 8px 15px;
  border-radius: 5px;
  color: #FFF;
  line-height: 17px;
  font-size: 13px;
  margin: ${props => props.margin};
  .fa {
    margin: 2px 5px 0 0;
  }
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 7px;
  right: 10px;
  cursor: pointer;
`;

class StatusAlert extends React.Component {

  static defaultProps = {
    margin: '10px 0 0 0',
  };

  render() {
    return (
      <AlertWrapper
        background={this.props.background}
        margin={this.props.margin}
      >
        {this.props.children}
        {
          this.props.onClose &&
            <CloseIconWrapper onClick={this.props.onClose}>
              <i className='fa fa-times' />
            </CloseIconWrapper>
        }
      </AlertWrapper>
    );
  }
}

export default StatusAlert;
